import { css } from 'styled-components';

export const fadeIn = css`
  animation-direction: forwards;
  animation-name: fadeIn;
  animation-duration: 0.5s;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const fadeInSlow = css`
  animation-direction: forwards;
  animation-name: fadeIn;
  animation-duration: 1s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const fadeInFast = css`
  animation-direction: forwards;
  animation-name: fadeIn;
  animation-duration: 0.4s;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const bounce = css`
  animation-name: bounce;
  animation-duration: 2s;
  animation-iteration-count: infinite;

  @keyframes bounce {
    0% {
      transform: translateY(0px);
    }

    10% {
      transform: translateY(8px);
    }

    30% {
      transform: translateY(0px);
    }
  }
`;

export const riseAndFadeIn = css`
  animation-direction: forwards;
  animation-name: riseAndFadeIn;
  animation-duration: 0.5s;

  @keyframes riseAndFadeIn {
    0% {
      transform: translateY(20px);
      opacity: 0%;
    }
    50% {
      transform: translateY(0px);
    }
    100% {
      opacity: 100%;
    }
  }
`;
